import React, { useState, useRef } from 'react';
import axiosInstance from '../../../../axiosConfig';
import axios from 'axios';
import styles from '../../Economy/Countries/ChatNumbers.module.css'; // Import the CSS module
import SummaryDisplayChatLongTerm from './SummaryDisplayChatLongTerm';

const ChatNumbersLongTermOutlook = ({ inputData }) => {
  const [customerRequest, setCustomerRequest] = useState('');
  const [responseMessage, setResponseMessage] = useState('');
  const [chatHistory, setChatHistory] = useState([]);
  const [displayChatHistory, setDisplayChatHistory] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showChat, setShowChat] = useState(false); 
  const source = useRef(axios.CancelToken.source());

  const handleSubmit = (event) => {
    event.preventDefault();
    setLoading(true);
    const maxRetries = 8;
    const delay = 2000; // Retry delay in milliseconds
    let retries = 0;

    const fetchData = async () => {
      try {
        source.current.cancel('Operation canceled by the user.');
        source.current = axios.CancelToken.source();

        const modifiedCustomerRequest = `${customerRequest} under the Money and Banking catergory`;

        const response = await axiosInstance.post('/chat_with_numbers_long_term_outlook/', {
          customer_request: modifiedCustomerRequest,
          country: inputData.code,
          chat_history: chatHistory,
        }, {
          cancelToken: source.current.token,
        });

        if (response.data.error === 'Connection error.') {
          throw new Error('Connection error.');
        }

        const responseText = response.data.response || response.data;

        setChatHistory([
          ...chatHistory,
          { role: 'user', content: customerRequest },
          { role: 'assistant', content: responseText },
        ]);
        setDisplayChatHistory([
          ...displayChatHistory,
          { role: 'user', content: customerRequest },
          { role: 'assistant', content: responseText },
        ]);

        setCustomerRequest('');
        setResponseMessage('');
        setLoading(false);
      } catch (error) {
        console.error('There was an error!', error);

        if ((error.message === 'Connection error.' || (error.response && error.response.data && error.response.data.error === 'Connection error.')) && retries < maxRetries) {
          retries += 1;
          //console.log(`Connection error. Retrying (${retries}/${maxRetries}) in ${delay / 1000} seconds...`);
          setTimeout(fetchData, delay);
        } else {
          setResponseMessage(error.response ? error.response.data.error : 'An error occurred. Please try again.');
          setLoading(false);
        }
      }
    };

    fetchData();
  };

  const handleChatButtonClick = () => {
    setShowChat(!showChat); 
    if (showChat) { 
      setChatHistory([]); 
      setDisplayChatHistory([]); 
    }
  };

  return (
    <div className={styles.wrapper}>
      <div style={{ marginBottom: '20px' }}>
        <button onClick={handleChatButtonClick} className={styles.chatButton}>Chat with Long Term Outlook</button>
      </div>

      {showChat && (
        <div className={styles.chatContainer}>
          <div className={styles.messagesArea}>
            {displayChatHistory.map((message, index) => (
              <div key={index} className={`${styles.messageWrapper} ${styles[message.role]}`}>
                <div className={`${styles.messageBubble} ${styles[message.role]}`}>
                  {message.role === 'user' ? (
                    <pre className={styles.messageContent}>{message.content}</pre>
                  ) : (
                    <SummaryDisplayChatLongTerm content={message.content} />
                  )}
                </div>
              </div>
            ))}

            {loading && <p className={styles.loadingText}>Thinking, please wait…</p>}

            {responseMessage && (
              <div className={styles.errorMessage}>
                {responseMessage}
              </div>
            )}
          </div>

          <form onSubmit={handleSubmit} className={styles.formContainer}>
            <textarea
              value={customerRequest}
              onChange={e => { setCustomerRequest(e.target.value); setResponseMessage(''); }}
              placeholder="Ask about numbers..."
              rows="1"
              className={styles.textarea}
            />
            <button
              type="submit"
              disabled={loading}
              className={styles.submitButton}
              title="Send"
              style={{ width: 34, minWidth: 34, maxWidth: 34, height: 34, flexShrink: 0, flexGrow: 0, padding: 0, borderRadius: '50%' }}
            >
              {loading ? '…' : '↑'}
            </button>
          </form>
        </div>
      )}
    </div>
  );
};

export default ChatNumbersLongTermOutlook;
